import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { IconClose, IconPhone } from '@travel-frontend/icons';
import { useTranslation } from 'next-i18next';
import { Hotline } from '../../../../../../components/HotlineBarFixed/components/Hotline/index.js';
import { Container } from '../../../../../../components/HotlineBarFixed/components/Layout/components/Container.js';
import { Control } from '../../../../../../components/HotlineBarFixed/components/Layout/components/Control.js';
import { Container as HotlineContainer } from '../../../../../../components/HotlineBarFixed/components/Layout/components/Desktop/components/Container.js';
import { LabelSmall } from '../../../../../../primitives/index.js';
export const LayoutDesktop = ({
  phoneNumber,
  handleClick,
  openingHours,
  isDateInHolidayRange,
  specialImage
}) => {
  const {
    t
  } = useTranslation();
  return _jsxs(Container, {
    children: [specialImage ?? _jsx(IconPhone, {}), _jsxs(HotlineContainer, {
      children: [_jsx(LabelSmall, {
        color: "contentInversePrimary",
        children: isDateInHolidayRange ? t('header:hotline.stickySpecialDaysText') : t('header:hotline.stickyText')
      }), _jsx(Hotline, {
        openingHours: openingHours,
        phoneNumber: phoneNumber,
        children: phoneNumber
      })]
    }), _jsx(Control, {
      onClick: handleClick,
      children: _jsx(IconClose, {})
    })]
  });
};